import * as angular from "angular";
import {IController} from "angular";

export class BringozRruleRecurringTypeSelectComponent implements IController {
  type: any;
  isRequired: any;
  isDisabled: any;
  allowedTypes: string[];
  onChange: Function;

  rruleTypes: any;

  constructor(private commonsConstants) {
  }

  $onInit() {
    this.rruleTypes = this.allowedTypes ?
      this.commonsConstants.rruleTypes.filter((rruleType) => this.allowedTypes.includes(rruleType.type)) :
      this.commonsConstants.rruleTypes;
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozRruleRecurringTypeSelect', {
    bindings: {
      type: '<',
      isRequired: '<?',
      isDisabled: '<?',
      allowedTypes: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-rrule-recurring-type-select/bringoz-rrule-recurring-type-select.html',
    controller: BringozRruleRecurringTypeSelectComponent
  });
